import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { PdfJs } from 'core/types'

interface bookmarkType {
  doc?: PdfJs.PdfDocument
  magazineId: number
  url?: string
  magazineTitle?: string,
  isPurchase?:number,
  pages: {
    pageNumber: number
    source: string
  }[]
}
interface pagesState {
  // bookmarks: Record<number, number[]>
  bookmarks: bookmarkType[]
}

// Define the initial state using that type
const initialState: pagesState = {
  bookmarks: []
}

export const bookmarksSlice = createSlice({
  name: 'bookmarks',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    // addBookmark: (
    //   state,
    //   action: PayloadAction<{
    //     magazineId: number
    //     page: number[]
    //   }>
    // ) => {
    //   if (!state.bookmarks[action.payload.magazineId]) {
    //     state.bookmarks[action.payload.magazineId] = []
    //   }
    //   if (state.bookmarks[action.payload.magazineId].some((page) => action.payload.page.includes(page))) {
    //     const newPage = [...state.bookmarks[action.payload.magazineId]].filter((page: number) => !action.payload.page.includes(page))
    //     state.bookmarks[action.payload.magazineId] = newPage
    //   } else {
    //     state.bookmarks[action.payload.magazineId].push(...action.payload.page)
    //   }
    // },

    addBookmark: (
      state,
      action: PayloadAction<{
        doc?: PdfJs.PdfDocument
        magazineId: number
        url?: string
        magazineTitle?: string,
        isPurchase?:number,
        pages: {
          pageNumber: number
          source: string
        }[]
      }>
    ) => {
      if (state.bookmarks.findIndex((bookmark) => bookmark.magazineId === action.payload.magazineId) === -1) {
        state.bookmarks.push({
          doc: action.payload.doc,
          magazineId: action.payload.magazineId,
          url: action.payload.url,
          magazineTitle: action.payload?.magazineTitle,
          isPurchase: action.payload.isPurchase,
          pages: []
        })
      } else {
        const index = state.bookmarks.findIndex((bookmark) => bookmark.magazineId === action.payload.magazineId)
        state.bookmarks[index] = {
          ...state.bookmarks[index],
          pages: [...state.bookmarks[index].pages, ...action.payload.pages]
        }
      }
    },
    removeBookmark: (
      state,
      action: PayloadAction<{
        doc?: PdfJs.PdfDocument
        magazineId: number
        pages: number[]
      }>
    ) => {
      const index = state.bookmarks.findIndex((bookmark) => bookmark.magazineId === action.payload.magazineId)
      state.bookmarks[index] = {
        ...state.bookmarks[index],
        pages: [...state.bookmarks[index].pages].filter((item) => !action.payload.pages.some((page) => page === item.pageNumber))
      }
    },
    removeAllBookmark: (state) => {
      state.bookmarks = []
    }
  }
})
export const { addBookmark, removeBookmark, removeAllBookmark } = bookmarksSlice.actions

export default bookmarksSlice.reducer
